import { RecordList } from 'types/index';
import { FilterList } from 'filters/types';

/**
 * @param records
 * @param filters
 */
function filterRecords(records: RecordList, filters: FilterList): RecordList {
  return records.reduce(
    (acc, record) =>
      filters.map((filter) => filter(record)).every((result) => !result)
        ? acc.concat([record as never])
        : acc,
    [],
  );
}

export { filterRecords };
